import axios, {AxiosResponse} from 'axios'
import {PaymentOptionsQueryResponse} from './_models'
import {TPaymentOptionRequest} from '../../../coreGlobal/models/paymentOption'
import {ISelect} from '../../../coreGlobal/models/default'
import {Response} from '../../../_metronic/helpers'

const API_URL = process.env.REACT_APP_API_URL + '/api'

const PAYMENT_OPTION_URL = `${API_URL}/admin/payment_options`
const PAYMENT_OPTION_CATEGORY_URL = `${API_URL}/admin/payment-option-category`
const FRANCHISE_URL = `${API_URL}/admin/franchises`

const getPaymentOptions = (query: string): Promise<PaymentOptionsQueryResponse> => {
  return axios
    .get(`${PAYMENT_OPTION_URL}?${query}&include=category,franchise`)
    .then((d: AxiosResponse<PaymentOptionsQueryResponse>) => d.data)
}

const getPaymentOptionsById = (paymentOptionId: string | number) => {
  return axios
    .get(`${PAYMENT_OPTION_URL}/${paymentOptionId}?include=category,franchise,installmentFees`)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const updatePaymentOption = (paymentOptionId: string | number, data: TPaymentOptionRequest) => {
  return axios
    .put(`${PAYMENT_OPTION_URL}/${paymentOptionId}`, data)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const createPaymentOption = (data: TPaymentOptionRequest) => {
  return axios
    .post(`${PAYMENT_OPTION_URL}`, data)
    .then((response: any) => response.data)
    .then((response: any) => response.data)
}

const getPaymentOptionCategories = (): Promise<ISelect[] | undefined> => {
  return axios
    .get(`${PAYMENT_OPTION_CATEGORY_URL}/all`)
    .then((response: AxiosResponse<Response<ISelect[]>>) => response.data)
    .then((response: Response<ISelect[]>) => response.data)
}

const getFranchises = (): Promise<ISelect[]> => {
  return axios
    .get(`${FRANCHISE_URL}/all`)
    .then((response: AxiosResponse<Response<{id: number; name: string}[]>>) =>
      (response.data.data ?? []).map((franchise) => ({value: String(franchise.id), label: franchise.name}))
    )
}

export {
  getPaymentOptions,
  getFranchises,
  getPaymentOptionsById,
  updatePaymentOption,
  createPaymentOption,
  getPaymentOptionCategories,
}
